/** Textos do menu ⋮ da tabela (GLOSSARIO.md, "Listagens"). */
export const TABLE_ACTIONS_LABEL = "Opções da tabela";
export const TABLE_ACTIONS_EXPORT_LABEL = "Exportar Visualização";
export const TABLE_ACTIONS_SETTINGS_LABEL = "Configurações da Tabela";
